import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { MoldRevisionApiRoutesDto } from '../dto/mold-revision.dto';
import { Observable } from 'rxjs';
import { MoldRevision } from '../types/mold-revision';
import { Mold } from '../types/mold';
import { MoldLocation } from '../types/mold-location';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteMoldRevisionService extends IApiBackendRouteService {
  urlRoute = `${API_BASE_URL}/mold-revision`;

  create(
    body: MoldRevisionApiRoutesDto['create']['body']
  ): Observable<MoldRevision> {
    return this.http.post<MoldRevision>(this.urlRoute, body);
  }

  getMoldsByDepartment(departmentName: string): Observable<MoldRevision[]> {
    return this.http.get<MoldRevision[]>(this.urlRoute, {
      params: { departmentName },
    });
  }

  getMovableMoldsByDepartment(
    departmentName: string
  ): Observable<MoldRevision[]> {
    return this.http.get<MoldRevision[]>(`${this.urlRoute}/movable`, {
      params: { departmentName },
    });
  }

  update(
    id: number,
    body: MoldRevisionApiRoutesDto['update']['body']
  ): Observable<any> {
    return this.http.patch(`${this.urlRoute}/${id}`, body);
  }

  setToMachine(id: number, machine: string): Observable<MoldRevision> {
    return this.http.post<MoldRevision>(
      `${this.urlRoute}/${id}/set-to-machine`,
      {
        machine,
      }
    );
  }

  moveToLocation(
    id: number,
    nextLocationId: number | number[],
    userId: string
  ): Observable<Mold> {
    return this.http.patch<Mold>(`${this.urlRoute}/${id}/change-location`, {
      nextLocationId,
      userId
    });
  }

  moldsOutOfMachine(departmentName: string): Observable<MoldLocation[]> {
    return this.http.get<MoldLocation[]>(
      `${this.urlRoute}/out-of-machine?departmentName=${departmentName}`
    );
  }

  getByDepartmentSimple(departmentName: string): Observable<MoldRevision[]> {
    return this.http.get<MoldRevision[]>(
      `${this.urlRoute}/department-simple/${departmentName}`
    );
  }
}
